import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as T from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { getSaga } from "src/request/get";
import { putSaga } from "src/request/put";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

/*DAMAGE DEFINITION*/
export const getPicklistDamageDefinition = createAction(
  "GET_PICKLIST_DAMAGE_DEFINITION",
  ({ payload, params }: SagaActionParams<T.DamageDefinitionDto[]>) => ({
    payload,
    url: "/api/admin/admindamagedefinition/picklist" + (params ? params : ""),
  })
);
export const getDamageDefinitions = createAction(
  "GET_DAMAGE_DEFINITIONS",
  ({ payload, params }: SagaActionParams<T.DamageDefinitionDto[]>) => ({
    payload,
    url: "/api/admin/admindamagedefinition" + (params ? params : ""),
  })
);
export const getDamageDefinitionDetails = createAction(
  "GET_DAMAGE_DEFINITION_DETAILS",
  ({ payload, id }: SagaActionParams<T.DamageDefinitionDetailDto>) => ({
    payload,
    url: "/api/admin/admindamagedefinition/" + id,
  })
);
export const createDamageDefinition = createAction(
  "CREATE_DAMAGE_DEFINITION",
  ({ payload, body }: SagaActionParams<T.DamageDefinitionDto>) => ({
    payload,
    url: "/api/admin/admindamagedefinition",
    body,
  })
);
export const updateDamageDefinition = createAction(
  "UPDATE_DAMAGE_DEFINITION",
  ({ payload, id, body }: SagaActionParams<T.DamageDefinitionDto>) => ({
    payload,
    url: "/api/admin/admindamagedefinition/" + id,
    body,
  })
);
export const deleteDamageDefinition = createAction(
  "DELETE_DAMAGE_DEFINITION",
  ({ payload, id }: SagaActionParams<T.DamageDefinitionDto>) => ({
    payload,
    url: "/api/admin/admindamagedefinition/" + id,
  })
);

//DAMAGE_DEFINITION PICKLIST OPTIONS
export const getPicklistOptionsDamageDefinitionId = createAction(
  "GET_DAMAGE_DEFINITION_OPTIONS_BY_DEFINITIONID",
  ({
    payload,
    params,
    id,
  }: SagaActionParams<T.DamageDefinitionPicklistOptionDto[]>) => ({
    payload,
    url:
      "/api/admin/admindamagedefinitionpicklistoptions/getbydefinitionid/" +
      id +
      (params ? params : ""),
  })
);
export const getDamageDefinitionPicklistOptionDetail = createAction(
  "GET_DAMAGE_DEFINITION_OPTION_DETAILS",
  ({ payload, id }: SagaActionParams<T.DamageDefinitionPicklistOptionDto>) => ({
    payload,
    url: "/api/admin/admindamagedefinitionpicklistoptions/" + id,
  })
);
export const addDamageDefinitionPicklistOption = createAction(
  "ADD_DAMAGE_DEFINITION_OPTIONS",
  ({
    payload,
    body,
  }: SagaActionParams<T.DamageDefinitionPicklistOptionDto>) => ({
    payload,
    body: body,
    url: "/api/admin/admindamagedefinitionpicklistoptions",
  })
);
export const updateDamageDefinitionPicklistOption = createAction(
  "UPDATE_DAMAGE_DEFINITION_OPTIONS",
  ({
    payload,
    id,
    body,
  }: SagaActionParams<T.DamageDefinitionPicklistOptionDto>) => ({
    payload,
    body: body,
    url: "/api/admin/admindamagedefinitionpicklistoptions/" + id,
  })
);
export const deleteDamageDefinitionPicklistOption = createAction(
  "DELETE_DAMAGE_DEFINITION_OPTIONS",
  ({ payload, id }: SagaActionParams<T.DamageDefinitionPicklistOptionDto>) => ({
    payload,
    url: "/api/admin/admindamagedefinitionpicklistoptions/" + id,
  })
);

const damageDefinitionSaga = [
  //DAMAGE_DEFINITION PICKLIST OPTIONS
  takeLatest<any>(
    getPicklistDamageDefinition.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionDto[]>) =>
      getSaga<T.DamageDefinitionDto[]>(payload)
  ),
  takeLatest<any>(
    getPicklistOptionsDamageDefinitionId.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionPicklistOptionDto[]>) =>
      getSaga<T.DamageDefinitionPicklistOptionDto[]>(payload)
  ),
  takeLatest<any>(
    getDamageDefinitionPicklistOptionDetail.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionPicklistOptionDto[]>) =>
      getSaga<T.DamageDefinitionPicklistOptionDto[]>(payload)
  ),
  takeLatest<any>(
    getDamageDefinitionPicklistOptionDetail.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionPicklistOptionDto>) =>
      getSaga<T.DamageDefinitionPicklistOptionDto>(payload)
  ),
  takeLatest<any>(
    addDamageDefinitionPicklistOption.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionPicklistOptionDto>) =>
      postSaga<T.DamageDefinitionPicklistOptionDto>(payload)
  ),
  takeLatest<any>(
    updateDamageDefinitionPicklistOption.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionPicklistOptionDto>) =>
      putSaga<T.DamageDefinitionPicklistOptionDto>(payload)
  ),
  takeLatest<any>(
    deleteDamageDefinitionPicklistOption.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionPicklistOptionDto>) =>
      deleteSaga<T.DamageDefinitionPicklistOptionDto>(payload)
  ),

  //DAMAGE DEFINITIONS
  takeLatest<any>(
    getDamageDefinitions.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionDto[]>) =>
      getSaga<T.DamageDefinitionDto[]>(payload)
  ),
  takeLatest<any>(
    getDamageDefinitionDetails.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionDto>) =>
      getSaga<T.DamageDefinitionDto>(payload)
  ),
  takeLatest<any>(
    createDamageDefinition.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionDto>) =>
      postSaga<T.DamageDefinitionDto>(payload)
  ),
  takeLatest<any>(
    updateDamageDefinition.toString(),
    (payload: SagaGenericParams<T.DamageDefinitionDto>) =>
      putSaga<T.DamageDefinitionDto>(payload)
  ),
  takeLatest<any>(
    deleteDamageDefinition.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<T.DamageDefinitionDto>(payload)
  ),
];

export default damageDefinitionSaga;
